import { allTranslatedPathRecords, TranslatedPathRecord } from '../translated-paths';

export function findTranslationRecord(path: string): TranslatedPathRecord {
	// eslint-disable-next-line no-shadow
	const translatedPathRecord = allTranslatedPathRecords.find((translatedPathRecord) => {
		const pathsForAllLanguages = Object.values(translatedPathRecord);

		return pathsForAllLanguages.includes(path);
	});

	if (!translatedPathRecord) {
		throw new Error(`No translation record found for path "${path}"`);
	}

	return translatedPathRecord;
}
